// Generated by CoffeeScript 2.7.0
var ExportableTable;

export default ExportableTable = class ExportableTable {
  constructor(node) {
    this.element = DomMaster.wrap(node);
    if (!this.element.node) {
      return;
    }
    this.toggle_all_element = this.element.find('.js-toggle-all');
    this.exportable_file_check_box_elements = this.updateExportableFileCheckBoxElements();
    this.checked_count_element = this.element.find('.js-checked-count');
    this.tbody_element = this.element.find('.js-exportable-files-tbody');
    this.total_count = this.exportable_file_check_box_elements.length;
    this.checked_count = 0;
    this.bindingEvents();
  }

  bindingEvents() {
    this.element.node.proxy('change', '.js-exportable-file-check-box', (event) => {
      if (event._target.checked) {
        this.checked_count += 1;
      } else {
        this.checked_count -= 1;
      }
      return this.toggleSummary();
    });
    return this.element.node.proxy('change', '.js-toggle-all', (event) => {
      var checked;
      checked = event._target.checked;
      _.each(this.exportable_file_check_box_elements, function(check_box) {
        return check_box.node.checked = checked;
      });
      this.checked_count = checked ? this.total_count : 0;
      return this.toggleSummary();
    });
  }

  toggleSummary() {
    if (this.checked_count > 0) {
      this.element.addClass('item-checked');
      this.checked_count_element.html(` ${this.checked_count} `);
    } else {
      this.element.removeClass('item-checked');
    }
    return this.toggle_all_element.node.checked = this.checked_count === this.total_count;
  }

  updateExportableFileCheckBoxElements() {
    return this.exportable_file_check_box_elements = this.element.findAll('.js-exportable-file-check-box');
  }

  addFile(file_content) {
    this.tbody_element.prepend(file_content);
    this.total_count += 1;
    this.toggleSummary();
    return this.updateExportableFileCheckBoxElements();
  }

  removeFile(id) {
    var file_element;
    file_element = this.tbody_element.find(`#js_tr_exportable_file_${id}`);
    if (file_element.isPresent()) {
      if (file_element.find('.js-exportable-file-check-box').node.checked) {
        this.checked_count -= 1;
      }
      this.total_count -= 1;
      file_element.remove();
      this.toggleSummary();
      return this.updateExportableFileCheckBoxElements();
    }
  }

  removeFiles(ids) {
    return _.each(ids, (id) => {
      return this.removeFile(id);
    });
  }

};
